import React from 'react';
import { TldOfferExpand } from '../expand/TldOfferExpand';
import { TldOfferWidgetModule } from '../tldOfferWidget.module';
import { storefrontLayout } from './storefront.layout';
export const StorefrontExpand = _ref => {
  let domain = _ref.domain;
  return /*#__PURE__*/React.createElement(TldOfferWidgetModule.Provider, {
    Layouts: {
      customConfiguration: storefrontLayout
    }
  }, /*#__PURE__*/React.createElement(TldOfferExpand, {
    key: domain,
    domain: domain
  }));
};
//# sourceMappingURL=StorefrontExpand.js.map